// Application landing page at the app root; links out to each tool.
import { FC } from 'react';
import Header from '@amzn/awsui-components-core/header';
import ContentLayout from '@amzn/awsui-components-core/content-layout';
import Container from '@amzn/awsui-components-core/container';
import ColumnLayout from '@amzn/awsui-components-core/column-layout';
import Button from '@amzn/awsui-components-core/button';
import Box from '@amzn/awsui-components-core/box';
import { IS_BEHIND_MONS, MONS_ROUTE_BASE } from 'src/constants';
import { useTranslate } from 'src/hooks/useTranslate';
import { VALUE_MATCHING_BASE } from 'src/routes/valueMatching/routes';
import { MPCS_BASE } from 'src/routes/mpcs/routes';

const PAGE_BUNDLE = 'pages.home';

const BASE_PREFIX = IS_BEHIND_MONS ? MONS_ROUTE_BASE : '';
const VALUE_MATCHING_URL = `${BASE_PREFIX}${VALUE_MATCHING_BASE}`;
// mons_idp_label=amazonian skips the Mons IdP selection screen for MPCS users,
// sending them straight to the default federated IdP configured for internal users.
const MPCS_URL = `${BASE_PREFIX}${MPCS_BASE}?mons_idp_label=amazonian`;

const HomePage: FC = () => {
  const { translate } = useTranslate(PAGE_BUNDLE);

  return (
    <ContentLayout
      header={
        <Header variant="h1" description={translate('home_description')}>
          {translate('home_title')}
        </Header>
      }
    >
      <ColumnLayout columns={2}>
        <Container
          fitHeight
          header={<Header variant="h2">{translate('vm_title')}</Header>}
          footer={
            <Button
              variant="primary"
              iconName="angle-right"
              iconAlign="right"
              href={VALUE_MATCHING_URL}
              data-testid="home-value-matching"
            >
              {translate('vm_button')}
            </Button>
          }
        >
          <Box variant="p" color="text-body-secondary">
            {translate('vm_description')}
          </Box>
        </Container>

        <Container
          fitHeight
          header={<Header variant="h2">{translate('mpcs_title')}</Header>}
          footer={
            <Button
              variant="primary"
              iconName="angle-right"
              iconAlign="right"
              href={MPCS_URL}
              data-testid="home-mpcs"
            >
              {translate('mpcs_button')}
            </Button>
          }
        >
          <Box variant="p" color="text-body-secondary">
            {translate('mpcs_description')}
          </Box>
        </Container>
      </ColumnLayout>
    </ContentLayout>
  );
};

export default HomePage;
